import { render, staticRenderFns } from "./option_button.vue?vue&type=template&id=8b160ac6&scoped=true"
import script from "./option_button.vue?vue&type=script&lang=js"
export * from "./option_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b160ac6",
  null
  
)

export default component.exports